import { FontAwesomeIcon, IconProp, fatablelistclassicregular } from '@grc/ui-package';
import { useI18nState } from '../../../stores/settings/language-context';
import './quote-audit.scss';

// Shell/placeholder this pass (plan §5/§8/§9 item 3) - no cross-quote list
// endpoint exists yet (GET /quotes/audit/{streamId} returns one quote's raw
// event stream, not a page of rows), so this isn't a peer grid tab like the
// other 5. Recommended in the plan as a per-quote drill-down once scoped.
export default function QuoteAudit() {
  const { localeData } = useI18nState();

  return (
    <div className="quote-audit-empty" data-testid="quote_audit_empty">
      <FontAwesomeIcon icon={fatablelistclassicregular as IconProp} />
      <span>{localeData.SelectAQuoteToViewItsAuditTrail}</span>
    </div>
  );
}
